/**
 * LICENSE MANAGER
 *
 * Simple event emitter that bridges Axios interceptors (non-React code)
 * with the React component tree via LicenseContext.
 *
 * When any API interceptor detects a 402 response, it calls
 * emitLicenseRequired(message) which notifies all subscribers.
 */

// Set of listener functions
const listeners = new Set()

/**
 * Subscribe to license-required events.
 * Returns an unsubscribe function.
 *
 * @param {function} callback - Called with (message: string) when 402 detected
 * @returns {function} Unsubscribe function
 */
export const onLicenseRequired = (callback) => {
  listeners.add(callback)
  return () => listeners.delete(callback)
}

/**
 * Emit a license-required event to all subscribers.
 * Called from Axios response interceptors when a 402 status is received.
 *
 * @param {string} message - The error message from the API response
 */
export const emitLicenseRequired = (message) => {
  listeners.forEach((callback) => callback(message))
}
